/**
 * Checks if a given time in milliseconds passed
 * before the next request is allowed.
 */
export class TimeGuard {

  private lastTimeMs = 0;

  constructor(public defaultMinIntervalMs: number = 5000) {
  }

  try(minIntervalMs: number = this.defaultMinIntervalMs) {
    if (performance.now() - this.lastTimeMs < minIntervalMs)
      return false;
    this.lastTimeMs = performance.now();
    return true;
  }

}
